<template>
  <div class="page-container">
    <Hero title="Reserve a spot" imageUrl="Nicole+Jon-75.jpeg" altText="Engagement photo courtesy of Henry Cotton"/>
    <section class="container">
        <section>
            <h2 class="title">Need a place to stay?</h2>
            <p class="subtitle">We have reserved rooms at two hotels for you to stay at for either one or two nights. Please be mindful of the last day to book a room so that you don't miss out on the discounted rate.</p>
        </section>
        <div class="grid wrap">
            <div class="col col-size-6">
                <h3 class="header">Best Western Plus</h3>
                <p class="address">835 Upper Union Street <br> Franklin, MA 02038</p>
                <p>$180 / night <br> Last day to book: 6/5/2022</p>
                <a href="https://www.bestwestern.com/en_US/book/hotel-rooms.22067.html?groupId=W20DQ0B7" target="_blank"><button class="button">Book</button></a>
            </div>
            <div class="col col-size-6">
                <h3 class="header">Hampton Inn</h3>
                <p class="address">735 Union Street <br> Franklin, MA 02038</p>
                <p>$199 / night <br> Last day to book: 6/22/2022</p>
                <a href="https://www.hilton.com/en/book/reservation/deeplink/?ctyhocn=FRKMAHX&groupCode=CHHWNN&arrivaldate=2022-07-22&departuredate=2022-07-24&cid=OM,WW,HILTONLINK,EN,DirectLink&fromId=HILTONLINKDIRECT" target="_blank"><button class="button">Book</button></a>
            </div>
        </div>
         <section class="section">
            <h2 class="title">RSVP to our wedding</h2>
            <p class="subtitle">You can also RSVP to our wedding electronically! All responses must be submitted by June 27<sup>th</sup>. Click the button below to get started.</p>
            <a href="https://forms.gle/6zQ1VJChA4E5sgbp8" target="_blank"><button class="button">RSVP</button></a>
        </section>
    </section>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from '@/components/Hero.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'RSVP',
  components: {
    Hero,
    Footer
  }
}
</script>

<style scoped lang="scss">
    .container {
      margin: 80px auto;
      padding: 0 20px;
      text-align: center;
      max-width: 860px;

      .section {
          margin: 60px 0 0 0;
      }
      .title {
            font-size: 2.5rem;
            margin: 0;
            padding-bottom: 24px;
            font-weight: 100;
      }
      .subtitle {
          font-size: 1.125rem;
          margin: 0;
          padding-bottom: 32px;
      }
      .button {
              padding: 16px 32px;
              text-align: center;
              text-decoration: none;
              display: inline-block;
              font-size: 0.875rem;
              margin: 1rem auto 0 auto;
              transition-duration: 0.4s;
              cursor: pointer;
              background-color: #F5F5F5;
              color: #988ABD;
              border: 2px solid #988ABD;
              width: fit-content;
              font-weight: bold;
              letter-spacing: 0.1rem;
              text-transform: uppercase;
      }

      .button:hover {
          background-color: #988ABD;
          color: #FFF;
      }
      .button:focus {
          outline: none;
      }

      .grid {
        div {
            padding: 0 20px;

          .header {
            font-size: 1.125rem;
            text-transform: uppercase;
            letter-spacing: 0.15rem;
          }

          .address {
            margin-bottom: 0;
          }
        }
      }
    }

    @media only screen and (max-width: 768px) {
      .container {
        margin: 40px auto;

        .col:not(:last-child) {
          padding-bottom: 25px;
        }
      }
    }
</style>
